import axios from "axios";

const baseDomain = process.env.NODE_ENV == "development" ? 
  "http://localhost:5000" : process.env.VUE_APP_SO_API_BASE_URL;

const baseURL = `${baseDomain}/api`;

export default axios.create({
  baseURL
});
